import Constant from '@/const';
import axios from 'axios';

const getPharmacyCounter = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/pharmacy-counter`),
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default getPharmacyCounter;
